import { useQuery, useMutation } from '@tanstack/react-query';
import { ImportPreview, ImportStatus } from '@pf/shared';
import { apiUpload, apiPost, apiGet } from '../lib/api';

export function useUploadImport() {
  return useMutation({
    mutationFn: (file: File) =>
      apiUpload<ImportPreview>('/contacts/import/upload', file),
  });
}

export function useExecuteImport() {
  return useMutation({
    mutationFn: ({
      importId,
      mappings,
      options,
    }: {
      importId: string;
      mappings: Record<string, string>;
      options: { skipDuplicates: boolean; updateExisting: boolean; matchToReporters: boolean };
    }) =>
      apiPost<{ importId: string; status: string }>(`/contacts/import/${importId}/execute`, {
        mappings,
        options,
      }),
  });
}

export function useImportStatus(importId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: ['import-status', importId],
    queryFn: () =>
      apiGet<{ import: ImportStatus }>(`/contacts/import/${importId}/status`),
    enabled: !!importId && enabled,
    refetchInterval: (query) => {
      const status = query.state.data?.import?.status;
      if (status === 'completed' || status === 'failed') return false;
      return 1500;
    },
  });
}
